<template>
  <div id="profile">
    <the-top-bar title="Profile" />
    <div class="backButton">
      <button @click="$router.go(-1)" class="btn-floating waves-effect white ">
        <i class="material-icons grey-text text-darken-3 left">arrow_back</i>
      </button>
    </div>
    <div class="content">
      <div class="profile-icon">
        <i class="material-icons-outlined">
          account_circle
        </i>
      </div>
      <!--     <div class="profileIcon">
        <span class="material-icons-outlined">
          manage_accounts
        </span>
        <div class="center">Profile Edit</div>
      </div> -->
      <div class="card">
        <div class="card-content">
          <div class="row no-margins">
            <div class="input-field ">
              <div class="first_name">First Name</div>
              <input
                id="first_name"
                type="text"
                class="validate"
                v-model="user.first_name"
              />
            </div>
            <div class="input-field ">
              <div class="last_name">Last Name</div>
              <input
                id="last_name"
                type="text"
                class="validate"
                v-model="user.last_name"
              />
            </div>
            <div class="input-field ">
              <div class="email">Email</div>
              <input
                id="email"
                type="text"
                class="validate"
                disabled
                v-model="user.email"
              />
            </div>
            <div class="input-field ">
              <div class="email">School</div>
              <select class="browser-default" v-model="user.school">
                <option
                  :value="school.text"
                  v-for="school in schools"
                  :key="school.value"
                  >{{ school.text }}</option
                >
                <option value="other">Other</option>
              </select>
            </div>
            <div class="input-field col s12 no-padding">
              <div class="address">Address</div>
              <textarea
                id="address"
                class="materialize-textarea"
                style="width: 100%;"
                v-model="user.address_location"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="control-bar z-depth-1 row">
      <button
        class="btn btn-flat waves-effect btn-rounded white black-text col s5 m2"
        @click="$_goTo()"
      >
        Cancel
      </button>

      <button
        class="btn waves-effect amber lighten-1 btn-rounded black-text col s5 m2 right shadow-depth"
        @click="$_saveData()"
        :disabled="isProcessing"
      >
        Save
      </button>
    </div>
  </div>
</template>
<script>
import TheTopBar from "@/components/TheTopBar.vue";
import { mapActions, mapState } from "vuex";
import { updateUser, updateUserProfile } from "@/api/user.api";
import schools from "@/JsonSchemas/schoolList";
import M from "materialize-css";
export default {
  components: { TheTopBar },
  name: "Profile",
  props: {},
  data() {
    return {
      schools,
      isProcessing: false,
      user: {
        first_name: "",
        last_name: "",
        email: "",
        school: "",
        address_location: "",
      },
    };
  },
  mounted() {
    this.$_getData();
  },
  computed: { ...mapState({ userX: (state) => state.User.user }) },
  methods: {
    ...mapActions("User", ["updateUser"]),
    $_getData() {
      if (this.userX) {
        Object.keys(this.user).map((key) => {
          this.$set(this.user, key, this.userX[key]);
        });
      }

      setTimeout(() => {
        M.updateTextFields();
      });
    },
    async $_saveData() {
      if (this.isProcessing) return;
      this.isProcessing = true;
      const name = `${this.user.first_name} ${this.user.last_name}`;
      await updateUser(this.userX.id, { ...this.user, name }).then((res) =>
        this.updateUser({
          first_name: res.data.first_name,
          last_name: res.data.last_name,
          name: res.data.name,
        })
      );
      const payload = {
        fields: {
          address_location: this.user.address_location,
          school: this.user.school,
        },
      };
      await updateUserProfile(this.userX.profile, payload).then((res) => {
        this.updateUser(res.data.acf);
      });

      this.isProcessing = false;
    },
    $_goTo() {
      this.$router.push({ name: "Account" });
    },
  },
};
</script>
<style lang="scss" scoped>
#profile {
  .profile-icon {
    text-align: center;
    padding-top: 12px;
    &::after {
      content: "Edit Profile";
      text-align: center;
      display: block;
      margin-bottom: 15px;
      font-size: 22px;
      line-height: 1;
    }
    i {
      font-size: 84px;
      color: #252525;
    }
  }
  .backButton {
    left: 50%;
    position: fixed;
    @media screen and (max-width: 768px) {
      top: 84px;
    }
    top: 124px;
    max-width: 690px;
    transform: translateX(-50%);
    width: 100%;
    padding: 0 14px;
  }
  .content {
    max-width: 690px;
    padding: 16px;
    margin: auto;
    .card-content {
      padding: 0 24px;
    }
  }
  .control-bar {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 60px;
    width: 100%;
    padding: 1rem;
    margin: 0 !important;
    background: #fff;
  }
}
</style>
